import classnames from 'classnames'
import * as React from 'react'

import { Button } from '../../main/components/button'
import { generatePresetUrl } from './utils'

const SECTOR = [
  {
    href: { x: 'sector', y: 'instOwn', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Institutional Ownership',
  },
  {
    href: { x: 'sector', y: 'forwardPE', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Forward P/E Ratio',
  },
  {
    href: { x: 'sector', y: 'employees', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Employees',
  },
  {
    href: { x: 'sector', y: 'grossMargin', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Gross Margin',
  },
  {
    href: { x: 'sector', y: 'marketCap', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Market Capitalization',
  },
  {
    href: { x: 'sector', y: 'averageVolumeUsd', size: 'averageVolumeUsd', color: 'sector', idx: 'sp500' },
    label: 'Average USD Volume',
  },
  {
    href: { x: 'sector', y: 'sma200', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Simple Moving Average 200',
  },
  {
    href: { x: 'sector', y: 'rsi', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Relative Strength Index 14',
  },
  {
    href: { x: 'sector', y: 'shortInterestRatio', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Short Interest Ratio',
  },
]

const PERFORMANCE = [
  {
    href: { x: 'sector', y: 'lastChange', size: 'relativeVolume', color: 'lastChange', idx: 'sp500' },
    label: 'Today’s performance by Relative Volume',
  },
  {
    href: { x: 'sector', y: 'lastChange', size: 'marketCap', color: 'lastChange', idx: 'sp500' },
    label: 'Today’s performance by Market Capitalization',
  },
  {
    href: { x: 'sector', y: 'lastChange', size: 'averageVolumeUsd', color: 'lastChange', idx: 'sp500' },
    label: 'Today’s performance by Average USD Volume',
  },
  {
    // prettier-ignore
    href: { x: 'sector', y: 'lastChange', size: 'relativeVolume', color: 'lastChange', idx: 'any', ind: 'exchangetradedfund'},
    label: 'Today’s performance by Relative Volume (ETFs)',
  },
  {
    href: { x: 'sector', y: 'perfYtd', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Year-to-Date Performance',
  },
  {
    href: { x: 'sector', y: 'perf1w', size: 'marketCap', color: 'perf1w', idx: 'sp500' },
    label: '1-Week Performance',
  },
  {
    href: { x: 'sector', y: 'high52w', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: '52-Week High',
  },
  {
    href: { x: 'sector', y: 'low52w', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: '52-Week Low',
  },
  {
    href: { x: 'high52w', y: 'low52w', size: 'const', color: 'sector', idx: 'sp500' },
    label: '52-Week High vs Low',
  },
  {
    href: { x: 'insiderTrans', y: 'perf26w', size: 'marketCap', color: 'perf26w', idx: 'sp500' },
    label: 'Insider Transactions vs 6-Month Performance',
  },
  {
    href: { x: 'instOwn', y: 'perf26w', size: 'marketCap', color: 'perf26w', idx: 'sp500' },
    label: 'Institutional Ownership vs 6-Month Performance',
  },
  {
    href: { x: 'marketCap', y: 'perf52w', size: 'marketCap', color: 'perf52w', idx: 'sp500' },
    label: 'Market Capitalization vs 12-Month Performance',
  },
  {
    href: { x: 'roa', y: 'perf52w', size: 'marketCap', color: 'perf52w', idx: 'sp500' },
    label: 'ROA vs 12-Month Performance',
  },
  {
    href: { x: 'rsi', y: 'perf4w', size: 'marketCap', color: 'perf4w', idx: 'sp500' },
    label: 'Relative Strength Index 14 vs 4-Week Performance',
  },
  {
    href: { x: 'shortInterestRatio', y: 'rsi', size: 'marketCap', color: 'perf4w', idx: 'sp500' },
    label: 'Short Interest Ratio vs Relative Strength Index 14',
  },
]

const OTHER = [
  {
    href: { x: 'employees', y: 'sales', size: 'marketCap', color: 'const', tickers: 'AAPL,GOOG,MSFT,AMZN,FB' },
    label: 'Employees vs Sales in AAPL, GOOG, MSFT, AMZN, FB',
  },
  {
    href: { x: 'PE', y: 'forwardPE', size: 'marketCap', color: 'perf52w', sec: 'technology', cap: 'largeover' },
    label: 'P/E vs Forward P/E Ratio in Large cap. Technology Stocks',
  },
  {
    href: { x: 'consRecom', y: 'order', size: 'const', color: 'consRecom' },
    label: 'Analyst Recommendations Distribution - Buy Bias',
  },
  {
    href: { x: 'consRecom', y: 'sector', size: 'const', color: 'consRecom' },
    label: 'Analyst Recommendations Distribution by sector - Buy Bias',
  },
  {
    href: { x: 'income', y: 'sales', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: 'Income vs Sales (S&P 500)',
  },
  {
    href: { x: 'eps5Years', y: 'sales5Years', size: 'marketCap', color: 'sector', idx: 'sp500' },
    label: '5-Year EPS vs Sales growth (S&P 500)',
  },
]

interface PresetsModalProps {
  className?: string
  generatePresetUrl: (preset: Record<string, any>) => string
  onClose: (ev: React.MouseEvent) => void
}

class PresetsModal extends React.Component<PresetsModalProps> {
  static defaultProps = {
    generatePresetUrl,
  }

  render() {
    return (
      <div className={classnames(this.props.className, 'overlay modal is-presets')} onClick={this._hideModalOverlay}>
        <div className="content">
          <form id="modal-form">
            <div className="header">
              <h3 id="modal-title">Bubbles presets</h3>
              <button id="modal-close" type="button" className="close" onClick={this._closeModal}>
                ×
              </button>
            </div>
            <div className="body" id="modal-body">
              <h2>By Sector (S&P 500)</h2>
              {SECTOR.map((link) => (
                <React.Fragment key={link.label}>
                  <a href={this.props.generatePresetUrl(link.href)}>{link.label}</a>
                  <br />
                </React.Fragment>
              ))}

              <h2>By Performance (S&P 500)</h2>
              {PERFORMANCE.map((link) => (
                <React.Fragment key={link.label}>
                  <a href={this.props.generatePresetUrl(link.href)}>{link.label}</a>
                  <br />
                </React.Fragment>
              ))}

              <h2>Other</h2>
              {OTHER.map((link) => (
                <React.Fragment key={link.label}>
                  <a href={this.props.generatePresetUrl(link.href)}>{link.label}</a>
                  <br />
                </React.Fragment>
              ))}
            </div>
          </form>
        </div>
      </div>
    )
  }

  _closeModal = (e: React.MouseEvent) => {
    e.preventDefault()
    this.props.onClose(e)
  }

  _hideModalOverlay = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      this._closeModal(e)
    }
  }
}

interface PresetsProps {
  generatePresetUrl?: (preset: Record<string, any>) => string
  className?: string
  isDark?: boolean
}

export function Presets({ className, generatePresetUrl, isDark }: PresetsProps) {
  const [showPresets, setShowPresets] = React.useState(false)
  return (
    <>
      <Button leftContent="ideaLoad" theme="transparent" className={className} onClick={() => setShowPresets(true)}>
        Load preset
      </Button>
      {showPresets && (
        <PresetsModal
          className={isDark ? 'is-dark' : undefined}
          onClose={() => setShowPresets(false)}
          generatePresetUrl={generatePresetUrl}
        />
      )}
    </>
  )
}
